import { createSlice } from '@reduxjs/toolkit'
import name from './name'

const initialState = {
  progress: 0,
  total: 0,
  loading: false,
  result: null
}
// Store
export const content = createSlice({
  name,
  initialState,
  reducers: {
    setProgress: (state, { payload }) => {
      const { progress, total } = payload
      state.progress += parseInt(progress)
      state.total = parseInt(total)
    },
    setTotalUsers: (state, { payload }) => {
      const { total } = payload
      state.total = parseInt(total)
    },
    setLoading: (state, { payload }) => {
      state.loading = payload
    },
    setResult: (state, { payload }) => {
      state.result = payload.result
      state.total = payload.result.total
    },
    reset: () => initialState
  }
}
)

export const {
  setProgress,
  setTotalUsers,
  setLoading,
  setResult,
  reset
} = content.actions

export default content.reducer
